export default __webpack_public_path__ + "static/media/wework.1657d6e8.png";